import { sendEmailVerification } from "firebase/auth";

export const sendEmailVerificationToCurrentUser = (mainAuth) => {
  sendEmailVerification(mainAuth.currentUser).then(function () {
    // Email sent.
    console.log('Email Sent!!!')
  }).catch(function (error) {
    console.log('Email NOT Sent')
    // An error happened.
  });
}

// {ignoreId: true}
// {returnFirstObject: true}
// {uivi: xxx, isCombinedData}